import { temAcesso } from '@/shared/auth/temAcesso'
import itensDespesasRotas from '../itensDespesas/ItensDespesasRotas'
import RateiosRotas from '../rateios/RateiosRotas'

const Despesas = () => import('./Despesas.vue')
const Despesa = () => import('./Despesa.vue')
const InserirAtualizarDespesaForm = () => import('./InserirAtualizarDespesaForm.vue')

export default {
    path: 'despesas',
    name: 'DespesasGerais_Fornecedores_Despesas',
    component: Despesas,
    beforeEnter(to, from, next) {
        if (temAcesso('DESP-GERAIS-FORN-00')) {
            next();
        }
    },
    children: [
        {
            path: 'inserir',
            name: 'DespesasGerais_Fornecedores_Despesas_Inserir',
            component: InserirAtualizarDespesaForm,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-FORN-01')) {
                    next();
                }
            }
        },
        {
            path: ':despesaId/atualizar',
            name: 'DespesasGerais_Fornecedores_Despesas_Atualizar',
            component: InserirAtualizarDespesaForm,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-FORN-02')) {
                    next();
                }
            }
        }, 
        {
            path: ':despesaId',
            name: 'DespesasGerais_Fornecedores_Despesas_Detalhar',
            component: Despesa,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-FORN-00')) {
                    next()
                }
            }, 
            children: [itensDespesasRotas, 
                // RateiosRotas
            ]
        }
    ]
}